// This code has been simplified to just support help bubbles, but the term 'HelpAssistant' remains as there are too many places
// that refer to it (css, js, cshtml, multiple solutions) so we'll leave the names alone

function InitHelpAssistant() {
    insertHelpButtons();
    $("body").on("click", ".helpAssistantButton[data-help-title!='Routing number'],a[data-help]", ShowPopupHelp);
    $("#PrivacyMessageLink").click(hideAllPopovers);

    //hook up all help popovers to close when click outside them
    $('body').on('click', function (e) {
        $('[data-help]').each(function () {
            if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
                $(this).popover('destroy');
            }
        });
    });
}

function insertHelpButtons() {
    $("input[data-help],select[data-help],span[data-help]").each(function () {
        if ($(this).closest(".purchasePopUp").length == 0) {        // Not currently supported inside a dialog
            var elementName = $(this).attr("name");
            var helpText = $(this).data("help");
            if (!!$(this).data("forcontrol")) elementName = $(this).data("forcontrol");
            var $label = $("label[for='" + elementName + "'], span[data-help-for='" + elementName + "']");
            if ($label.has(".helpAssistantButton").length) return;
            var helpTitle = $("[name='" + elementName + "']").data("help-title");
            if (helpTitle == null)
                helpTitle = $("[name='" + elementName + "']").data("field-prettyname");
            var $button = $("<i class='infoIcon material-icons helpAssistantButton' aria-hidden='true'>" + "info_outlined" + "</i>");
            $button.attr("data-help", helpText);
            $button.attr("data-help-title", helpTitle);
            if (!!$label.data("help-placement")) $button.attr("data-help-placement", $label.data("help-placement"));

            // We never want the help assistant button to wrap onto it's own line but we also want the text to be screen-reader accessible
            var labelText = $label.length > 0 ? $label.html().trim() : "";
            if (labelText.length > 0) {
                $label.addClass("helpAssistantButtonContainer");
                $label.html("<span class='helpAssistantButtonLabel'>" + labelText + "</span>&nbsp;");
                $button = $("<span>" + $button.get(0).outerHTML + "</span>");
            }
            $label.append($button);
        }
    });
    $("a[data-help]").each(function () {
        if ($(this).data("help-title") === undefined)
            $(this).data("help-title", $(this).text());
    });
}

function hideAllPopovers() {
    $(".helpAssistantButton:not(.helpExplainWhy),a").popover("destroy");
}

function ShowPopupHelp(e) {
    e.preventDefault();
    var lastHelpText = $(this).data("help");
    var openedHelpPopupClickedAgain = ($(this).next(".popover").length > 0);
    hideAllPopovers();
    if (!openedHelpPopupClickedAgain) {
        var title = $(this).data("help-title");
        var titleTemplate = $("#AssistantPopupTitleTemplate").html();
        titleTemplate = titleTemplate.replace("{title}", title);
        var placement = "top";
        if (!!$(this).data("help-placement")) placement = $(this).data("help-placement");
        $(this).popover({ title: titleTemplate, content: lastHelpText, html: true, placement: placement, trigger: 'manual' }).popover("show");
        $(".popoverClose").click(hideAllPopovers);
    }

    //remove the link behavior from pop-ups so don't jump to top of screen
    $('a[href="#"]').click(function (e) {
        e.preventDefault();
    });
}


//# sourceURL=_HelpAssistant.js